/*
Template Name: Admin Template
Author: Wrappixel

File: js
*/
// ==============================================================
// Auto select left navbar
// ==============================================================
$(function () {
    "use strict";
    var url = window.location + "";
    url = url.split(/[?#]/)[0];
    var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
    path = path.split(/[?#]/)[0];
    if (path.length == 0) path = "home";

    // Pick SINGLE best match — anchor with the longest matched parentFor string.
    // Before this was `.filter()` returning every anchor whose parentFor substring
    // matched the URL path. Problem: if menu A has parentFor "procesy" and menu B
    // has "procesy/scenare", on `/procesy/scenare` BOTH match and both get .active.
    // Now we score each anchor by length of best match and keep only the winner;
    // exact href match gets max priority. Behavior for non-overlapping menu items
    // is unchanged.
    var bestEl = null;
    var bestLen = 0;
    $("ul#sidebarnav a").each(function () {
        var localBest = 0;
        if (this.dataset.parentFor) {
            try {
                var parentFor = JSON.parse(this.dataset.parentFor);
                for (var i = 0; i < parentFor.length; i++) {
                    var v = parentFor[i];
                    if (path.indexOf(v) !== -1 && v.length > localBest) {
                        localBest = v.length;
                    }
                }
            } catch (e) {
                /* malformed JSON — ignore */
            }
        }
        // Exact href match wins over any parentFor substring match.
        if (this.href === url || this.href === path) {
            localBest = Math.max(localBest, path.length + 1);
        }
        if (localBest > bestLen) {
            bestLen = localBest;
            bestEl = this;
        }
    });
    var element = bestEl ? $(bestEl) : $();
    element.parentsUntil(".sidebar-nav").each(function (index) {
        if ($(this).is("li") && $(this).children("a").length !== 0) {
            $(this).children("a").addClass("active");
            $(this).parent("ul#sidebarnav").length === 0 ? $(this).addClass("active") : $(this).addClass("selected");
        } else if (!$(this).is("ul") && $(this).children("a").length === 0) {
            $(this).addClass("selected");
        } else if ($(this).is("ul")) {
            $(this).addClass("in");
        }
    });

    element.addClass("active");
    $("#sidebarnav a").on("click", function (e) {
        if (!$(this).hasClass("active")) {
            // hide any open menus and remove all other classes
            $("ul", $(this).parents("ul:first")).removeClass("in");
            //$("a", $(this).parents("ul:first")).removeClass("active");

            // open our new menu and add the open class
            $(this).next("ul").addClass("in");
            $(this).attr("aria-expanded", "true");
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
            $(this).parents("ul:first").removeClass("active");
            $(this).attr("aria-expanded", "false");
            $(this).next("ul").removeClass("in");
        }
    });
    $("#sidebarnav >li >a.has-arrow").on("click", function (e) {
        e.preventDefault();
    });

    // Auto scroll to the active nav
    if ($(window).width() > 768 || window.Touch) {
        $(".scroll-sidebar").animate(
            {
                //  scrollTop: $("#sidebarnav .sidebar-item.selected").offset().top -250
            },
            500
        );
    }
});
